import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import FileUploader from './../FileUploader'
import HexPicker from './../HexPicker'
import { t } from '../../utils/i18n'
import Popover from '../Popover'
import {
  backgroundImageUploaded,
  backgroundRemoveImage,
  backgroundSetColor,
  backgroundSetMode
} from '../../actions'

const BackgroundPopover = () => {
  const dispatch = useDispatch()
  const background = useSelector((state) => state.bikeConfig.background)
  const [backgroundColor, setBackgroundColor] = useState(background.color)

  const isHex = (str) => {
    return /^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/.test(str)
  }

  const hexValidation = (e) => {
    let value = e.target.value
    if (value.charAt(0) !== '#') {
      value = `#${value.charAt(0)}`
    }
    setBackgroundColor(value)
    const validation = isHex(value.substring(1))
    if ((value.length === 4 || value.length === 7) && validation) {
      dispatch(backgroundSetColor(value))
    }
  }

  return (
    <Popover
      width={'250px'}
      alignTo=".velorbis-customizer-background-component"
    >
      <div className="velorbis-customizer-popover-header">
        {t('background')}
      </div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll velorbis-customizer-space-dist-v">
        <div className="velorbis-customizer-form-control">
          <label>{t('background_color')}</label>
          <HexPicker
            value={background.color}
            onChange={(color) => dispatch(backgroundSetColor(color))}
          />
          <input
            type="text"
            className="velorbis-customizer-input velorbis-customizer-sm-space-top"
            value={backgroundColor}
            onChange={hexValidation}
          />
        </div>
        {background.image ? (
          <div className="velorbis-customizer-space-dist-v">
            <div className="velorbis-customizer-form-control">
              <label>{t('background_image')}</label>
              <img
                className="velorbis-customizer-file-preview"
                src={background.image}
                alt="file-preview"
              />
              <div className="velorbis-customizer-popover-buttons velorbis-customizer-sm-space-top">
                <button
                  className="velorbis-customizer-button velorbis-customizer-button-sm"
                  onClick={() => dispatch(backgroundRemoveImage())}
                >
                  {t('background_remove')}
                </button>
              </div>
            </div>

            <div className="velorbis-customizer-form-control">
              <label>{t('background_image_mode')}</label>
              <select
                className="velorbis-customizer-input"
                value={background.mode}
                onChange={(e) => dispatch(backgroundSetMode(e.target.value))}
              >
                <option value="cover">{t('background_mode_cover')}</option>
                <option value="contain">{t('background_mode_contain')}</option>
                <option value="repeat">{t('background_mode_repeat')}</option>
              </select>
            </div>
          </div>
        ) : (
          <div className="velorbis-customizer-form-control">
            <label>{t('background_upload_label')}</label>
            <FileUploader
              uploaded={(file) => dispatch(backgroundImageUploaded(file))}
            />
          </div>
        )}
      </div>
    </Popover>
  )
}

export default BackgroundPopover
